/**
 * Classe responsável por gerenciar a criação do raio do stop
 * Created by adalto on 5/13/14.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.LayerExpandedRadius = (function () {

    function LayerExpandedRadius () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'expanded_radius_route';
        this.RESOURCE_LAYER = 'RouteDetail.ToolBar.Layers.ExpandedRadiusStop';

        var instanceToDataClass = null;

        this.setInstanceToClassData = function (instance) {
            instanceToDataClass = instance;
        };

        this.afterClickOnCheckBox = function (element) {

            var _element = element.target;

            this.setLayerStatusOnLocalStorageByTagName(_element.checked);

            if (instanceToDataClass) {

                if (_element.checked) {
                    instanceToDataClass.drawExpandedRadiusFromStop();
                } else {
                    instanceToDataClass.removePositionExpandedRadius();
                }

            }

        };



    }

    return LayerExpandedRadius;

})();
